import Vue from "vue";
import OrdersList from "./components/orders-list";
import Preloader from "./components/preloader";
import ProgressContainer from "./components/progressContainer";
import "@egjs/vue-flicking";

const defaultItemsOnPage = 10;

document.addEventListener('DOMContentLoaded', function () {
    const createHistoryPageApp = function () {
        const historyPageFormApp = new Vue({
            el: "#app",
            template: "#page-content",
            components: {
                'orders-list': OrdersList,
                'preloader': Preloader,
                'progressContainer': ProgressContainer
            },
            data: {
                fetchedCurrentPage: [],
                htmlPager: {
                    selectedIndex: 0
                },
                progressState: false,
                firstFetchData: null,
                totalPages: null,
                getOrdersUrl: null,
                maxDotsDisplay: 7,
                itemsOnPage: defaultItemsOnPage
            },
            mounted: function () {
                let pageForm = document.getElementById("page-form");
                this.getOrdersUrl = pageForm.getAttribute("data-getOrdersUrl");
                this.firstFetch();
            },
            methods: {
                jumpToPage(destination: number) {
                    this.htmlPager.selectedIndex = destination-1;
                },
                pageUp(currentIndex: number) {
                    if (currentIndex < this.totalPages-1)
                        this.htmlPager.selectedIndex = currentIndex + 1;
                },
                pageDown(currentIndex: number) {
                    if (currentIndex > 0)
                        this.htmlPager.selectedIndex = currentIndex - 1;
                },
                progressSwitch(state: boolean) {
                    this.progressState = state;
                },
                async firstFetch() {

                    if (this.fetchedCurrentPage.length > 0) {
                        return
                    }
                    this.$emit('progressSwitch', true);
                    const fetchURL = this.getOrdersUrl + '?PageNumber=1&PageSize=' + this.itemsOnPage;
                    const response = await fetch(fetchURL);
                    const dataJSON = await response.json();
                    this.totalPages = dataJSON.TotalPages;
                    this.firstFetchData = await dataJSON.Orders;
                }
            },
            computed: {
                firstDotIndex():number {
                    let first = this.htmlPager.selectedIndex - 2;
                    if (first + this.maxDotsDisplay > this.totalPages)
                        first = this.totalPages + 1 - this.maxDotsDisplay;
                    if (first < 1)
                        first = 1;
                    return first;
                },

                lastDotIndex():number {
                    let last = this.firstDotIndex + this.maxDotsDisplay;
                    if (last > this.totalPages)
                        last = this.totalPages+1;
                    return last;
                },

                dotRange() {
                    return Array.from(new Array(this.lastDotIndex - this.firstDotIndex), (x, i) => i + this.firstDotIndex);
                },

                currentViewIndex() {
                    return this.htmlPager.selectedIndex;
                }
            }
        });
    }; // end historyPageFormApp

        createHistoryPageApp();

}, false);// end document.addEventListener('DOMContentLoaded'